export const availability_calendar = {};
